import React from 'react';
import './pageHeader.css';

const PageHeader = ({ title, description }) => {
    return (
        <div className="pageHeader">
            <h1 className="pageTitle">{title}</h1>
            <p className="pageDescription">{description}</p>
        </div>
    );
};

export default PageHeader;
